import React from 'react';

import Modal from 'common/Modal/Modal';
import {
	GenericP,
	FlexDiv,
	GenericDiv
} from 'commonStyles';
import ActionButtons from '../../bizLanding/components/actionButtons/actionButtons';
import * as S from './VideoPlayerStyles';
import VideoPlayer from './VideoPlayer';

const Modaldata = {
	title: '',
	img: null,
	imgstyle: null,
	btnTxt: null,
	customClass: 'videoModal'
};

const SubPop = ({ mybizLogo = {} }) => (
	<S.SubImwrap $width='300px' $direction='column' top_P='45' left_P='10' right_P='10'>
		<img crossOrigin='anonymous' alt='Mybiz Logo' {...mybizLogo} />
		<GenericP bottom_M='20' f_weight='700' fsize='22px' top_M='10'>
			Designed for businesses seeking flexibility and a wide range of choices.
		</GenericP>
		<ActionButtons $direction='column' signupTxt='GET STARTED' />
	</S.SubImwrap>);

const VideoPlayerModal = ({ handleVideo, isMobile, videoLink, mybizLogo = {}, height, subModal = true }) => (
	<Modal
		Modaldata={Modaldata}
		close
		handleModal={handleVideo}
		submodalPos='right'
		subModal={(isMobile || !subModal) ? null : <SubPop mybizLogo={mybizLogo} />}
		isResponsive>
		<FlexDiv height='100%' align={isMobile ? 'center' : 'flex-end'}>
			<GenericDiv right_M={isMobile ? '0' : '20'} $width={isMobile ? '100%' : '100%'}>
				<VideoPlayer
					width='100%'
					height={height || '100%'}
					url={videoLink}
					playing
					volume={0.5}
					controls
					autoPlay
				/>
			</GenericDiv>
		</FlexDiv>
	</Modal>);

export default VideoPlayerModal;
